module.exports = __webpack_public_path__ + "img/thumb-009.17ecdfa0.png";